import React from "react";
import moment from "moment";

import { Button, Grid, IconButton, InputAdornment, TextField, Tooltip, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import UploadFileIcon from "@mui/icons-material/UploadFile";

import Response from "components/Screens/PayrollUpload/Response";
import uploadPayrollCSV from "services/payrollUpload";

import "components/Screens/PayrollUpload/UploadFile.scss";

function UploadFile() {
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [response, setResponse] = React.useState(null);
  const [payrollDate, setPayrollDate] = React.useState(new Date());
  const [country, setCountry] = React.useState("Pakistan");
  const [payslipType, setPayslipType] = React.useState("Monthly");

  const isPayslipTypeSelectable = country === "Peru";

  const handleCountryChange = (e) => {
    const next = e.target.value;
    setCountry(next);
    if (next !== "Peru") {
      setPayslipType("Monthly");
    }
  };

  const handleChooseFile = (e) => {
    setSelectedFile(null);
    e.preventDefault();
    setSelectedFile(e.target.files[0]);
  };

  const handleDocUpload = async (e) => {
    e.preventDefault();
    if (selectedFile && selectedFile) {
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("country", country);
      formData.append("month", moment(payrollDate).format("YYYY-MM-DD"));
      formData.append("payslipType", payslipType);

      setLoading(true);
      try {
        const res = await uploadPayrollCSV(formData);
        setResponse(res);
      } catch (err) {
        setResponse({ error: "Failed to upload file. Please try again." });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Grid container direction="row" rowSpacing={3} columnSpacing={3}>
      <Grid container direction="row" columnSpacing={2} size={12} sx={{
        alignItems: "center"
      }}>
        <Grid size={3}>
          <input
            color="primary"
            accept="application/csv"
            type="file"
            onChange={handleChooseFile}
            id="icon-button-file"
            className="display-none"
          />
          <TextField
            value={selectedFile?.name || ""}
            fullWidth
            className="uploadfile-filename-input"
            id="userName"
            variant="outlined"
            placeholder="Selected File Name"
            size="small"
            name="email"
            slotProps={{
              input: {
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="start">
                    <Tooltip title="Choose File">
                      <label htmlFor="icon-button-file" className="m-0">
                        <input
                          color="primary"
                          accept="application/csv"
                          type="file"
                          onChange={handleChooseFile}
                          id="icon-button-file"
                          className="display-none"
                        />
                        <IconButton component="span" aria-label="icon-button-file">
                          <UploadFileIcon color="primary" />
                        </IconButton>
                      </label>
                    </Tooltip>
                  </InputAdornment>
                ),
              },
            }}
          />
        </Grid>

        <Grid size={2}>
          <TextField
            select
            value={country}
            onChange={handleCountryChange}
            className="uploadfile-country-select"
            id="country-select"
            variant="outlined"
            placeholder="Select Country"
            size="small"
            name="country"
            fullWidth
            slotProps={{
              input: {
                disableUnderline: true,
              },
              select: {
                native: true,
              },
            }}
          >
            <option value="Pakistan">Pakistan</option>
            <option value="Peru">Peru</option>
          </TextField>
        </Grid>

        <Grid size={2}>
          <TextField
            select
            value={payslipType}
            onChange={(e) => setPayslipType(e.target.value)}
            disabled={!isPayslipTypeSelectable}
            className="uploadfile-payslip-type-select"
            id="payslip-type-select"
            variant="outlined"
            placeholder="Select Payslip Type"
            size="small"
            name="payslipType"
            fullWidth
            slotProps={{
              input: {
                disableUnderline: true,
              },
              select: {
                native: true,
              },
            }}
          >
            <option value="Monthly">Monthly</option>
            <option value="CTS">CTS</option>
            <option value="Gratification">Gratification</option>
          </TextField>
        </Grid>

        <Grid size="auto">
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            localeText={{ fieldMonthPlaceholder: (params) => (params.contentType === "letter" ? "MMM" : "MM") }}
          >
            <DatePicker
              views={["month", "year"]}
              value={payrollDate}
              onChange={setPayrollDate}
              slotProps={{
                textField: { className: "uploadfile-datepicker" },
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid size="auto">
          <Button
            disableElevation
            disabled={!selectedFile || loading}
            variant="contained"
            onClick={handleDocUpload}
            className="uploadfile-upload-btn"
          >
            <Typography variant="h6" color="white">
              Upload File
            </Typography>
          </Button>
        </Grid>
      </Grid>
      {!loading && (
        <Grid size={12}>
          <Response data={response?.payload} />
        </Grid>
      )}
    </Grid>
  );
}

export default UploadFile;
